import { render } from "./ClassificationImage.view.vue?vue&type=template&id=49571d7e&scoped=true&ts=true"
import script from "./ClassificationImage.view.vue?vue&type=script&lang=ts"
export * from "./ClassificationImage.view.vue?vue&type=script&lang=ts"

import "./ClassificationImage.view.vue?vue&type=style&index=0&id=49571d7e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49571d7e"]])

export default __exports__